import { sendExportRequest, type PerformanceWithAccountFilter } from "features/Library/Common/utils/performanceUtils";
import packsDataService from "features/Licensing/Packs/services/packsDataService";

export const doAddOnsAccountsExport = (filter: PerformanceWithAccountFilter, fileName: string) => {
  let abortController = new AbortController();
  return sendExportRequest(
    (abortController) => packsDataService.getAddOnsAccountsExport(filter, abortController.signal),
    fileName,
    abortController,
  );
};

export const doAccountAddOnsExport = (customerId: number, filter: PerformanceWithAccountFilter, fileName: string) => {
  let abortController = new AbortController();
  const params = {
    ...filter,
    accounts: [customerId],
    includeMyData: false,
  };
  return sendExportRequest(
    (abortController) => packsDataService.getAccountAddOnsExport(params, abortController.signal),
    fileName,
    abortController,
  );
};
